import { useState } from 'react';
import {
  AccessPortalWrapper,
  AccessPortalInternal,
  AccessPortalTitle,
  AccessPortalParagraph,
  AccessPortalErrorText,
  AccessPortalButton,
  AccessPortalLogo,
} from './AccessPortal.styled';
import InputText from '../InputText/InputText';
import logo from '../../assets/evalLogo_dark.png';

function AccessPortal({ invalidAccessKey, onSubmit, loading }) {
  const [displayedCode, setDisplayedCode] = useState('');

  const handleSubmit = () => {
    if (displayedCode.trim()) {
      onSubmit(displayedCode.trim());
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleSubmit();
    }
  };

  return (
    <AccessPortalWrapper>
      <AccessPortalInternal>
        <AccessPortalLogo
          src={logo}
          alt="Logo"
          onClick={() => window.open('https://chargeathome.org/', '_blank')}
        />
        <AccessPortalTitle>Welcome Beta Testers!</AccessPortalTitle>
        <AccessPortalParagraph>
          Please enter your access key below:
        </AccessPortalParagraph>
        <InputText
          type="text"
          value={displayedCode}
          onChange={(value) => setDisplayedCode(value)}
          onKeyDown={handleKeyDown}
          placeholder="Access Key"
          width="300px"
          style={{ textAlign: 'center' }}
        />
        {invalidAccessKey && (
          <AccessPortalErrorText>
            The key you have entered is invalid or is no longer valid.
          </AccessPortalErrorText>
        )}
        <AccessPortalButton
          onClick={handleSubmit}
          disabled={!displayedCode.trim() || loading}
        >
          {loading ? 'Verifying...' : 'Start Testing'}
        </AccessPortalButton>
      </AccessPortalInternal>
    </AccessPortalWrapper>
  );
}

export default AccessPortal;
